module.exports = __webpack_public_path__ + "static/media/intro.082433b0.mp3";